import Vue from "vue";
import Vuetify from "vuetify/lib";
// eslint-disable-next-line import/no-extraneous-dependencies
import "@fortawesome/fontawesome-free/css/all.css"; // Ensure you are using css-loader

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#2E8037",
        tcdc_color : "#2E8037",
        secondary: "#b0bec5",
        anchor: "#8c9eff"
      }
    }
  },
  icons: {
    iconfont: "fa"
  }
});
